import sobre from './sobre'
import episodios from './episodios'
import elemencast from './elemencast'
import ferramentas from './ferramentas'

export {
    sobre,
    episodios,
    elemencast,
    ferramentas
}



// WEBPACK FOOTER //
// ./src/components/templates/index.js